<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
  body {
    background-color: black;
    color: white;
    font-family: Verdana, sans-serif;
    height: 100%;
  }

  p {
    margin-top: 15px;
    padding: 0 5%;
    text-align: left;
    text-indent: 15px;
  }

  .datelist-style {
    background-color: white;
    border-radius: 5px;
    color: black;
    margin: 25px auto;
    max-width: 250px;
  }

  .btn-secondary {
    border-color: darkgray;
  }

  .btn-secondary:hover {
    border-color: darkgray;
  }

  .btn-danger {
    border-color: burlywood;
  }

  .btn-danger:hover {
    border-color: burlywood;
  }

  .tippy-popper {
    min-width: 240px;
    text-align: center;
    width: auto;
  }

  .btn-secondary {
    background: linear-gradient(#E0E0E0, gray) no-repeat;
  }

  .btn-secondary:hover {
    background: linear-gradient(#C8C8C8, gray) no-repeat;
  }

  .tippy-popper p {
    text-align: center;
    text-indent: 0;
  }

  .tippy-popper h5 {
    font-size: 1rem;
  }

  text {
    fill: white;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue